import { render, staticRenderFns } from "./cate_goods_list.mpx?vue&type=template&id=3b63e283&scoped=true&component=true&componentId=cate_goods_list25d9b343"
import script from "./cate_goods_list.mpx?vue&type=script&lang=js&component=true&componentId=cate_goods_list25d9b343"
export * from "./cate_goods_list.mpx?vue&type=script&lang=js&component=true&componentId=cate_goods_list25d9b343"
import style0 from "./cate_goods_list.mpx?vue&type=style&index=0&id=3b63e283&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m25d9b343%22%7D&component=true&componentId=cate_goods_list25d9b343"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b63e283",
  null
  
)

export default component.exports